import ReactBarcode from 'react-barcode';
import Qrcode from './Qrcode';

type props = {
  isBarcode: boolean;
  value: string;
};
export default function BarCodeType({ isBarcode, value }: props) {
  return (
    <div style={{ textAlign: 'center' }}>
      {value ? <>{isBarcode ? <ReactBarcode value={value} width={1.5} /> : <Qrcode value={value} />}</> : 'dsa'}
    </div>
  );
}
